<template>
	<dialog-slot
			:title="title"
			@updateClose="onDrawerClose"
			@updateSave="onSave"
			width="100%"
	>

		<template slot="subTitle">
			<div class="baseGray body-2">
				Employee: <span class="text-green">{{ nameEmployee }}</span> | Period: <span class="baseOrange">{{ period }}</span>
			</div>
		</template>

		<div class="StatementsViewWrap">
			<main-table
					:headers="tableHeader"
					:listItems="tableItems"
					:flag="tableFlag"
					:is-create="false"
					:is-search="false"
					:is-filter-refresh="false"
					:is-export="false"
					:items-per-page-amount="10"
					:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
			></main-table>
		</div>

	</dialog-slot>
</template>

<script>
import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";

export default {
	name: "StatementView",
	components: { DialogSlot },
	props: {
		title: String,
		nameEmployee: String,
		period: String,
		tableFlag: String,
		tableHeader: Array,
		tableItems: Array,
	},
	data: () => ({
		dialogTitle: 'dialogTitle',
	}),
	methods: {
		onDrawerClose(type) {
			if ( type == "close" || type == "outside" ) this.onClose();
			if ( type == "cancel" ) this.onCancel();
		},
		onClose() {
			this.$emit("updateCloseDialog");
		},
		onCancel() {
			this.$emit("updateCloseDialog");
		},
		onSave() {
			this.$emit("updateSave");
		},
	}
};
</script>

<style scoped lang="scss"></style>
